import { render, staticRenderFns } from "./KullaniciEbeFormResultDataView.vue?vue&type=template&id=5a893d26&scoped=true"
import script from "./KullaniciEbeFormResultDataView.vue?vue&type=script&lang=js"
export * from "./KullaniciEbeFormResultDataView.vue?vue&type=script&lang=js"
import style0 from "./KullaniciEbeFormResultDataView.vue?vue&type=style&index=0&id=5a893d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a893d26",
  null
  
)

export default component.exports